import { ArrowNavigation } from 'components/ArrowNavigation';
import { Box } from 'components/Box';
import { Button } from 'components/Button/Button';
import { CarouselState } from 'components/Carousel';
import { Hide } from 'components/Hide';
import { Text } from 'components/Text/Text';
import { colors } from 'theme';

type Props = {
  carouselState: CarouselState;
  fullWidth: boolean;
};

export function SlideshowNavigation({ carouselState, fullWidth }: Props) {
  const {
    currentPage,
    pageCount,
    goToNextPage,
    goToPreviousPage,
    hasPreviousPage,
    hasNextPage,
  } = carouselState;

  if (pageCount <= 1) return null;

  return (
    <>
      <Hide md={fullWidth} lg={fullWidth} xl={fullWidth}>
        <ArrowNavigation
          nextPage={goToNextPage}
          prevPage={goToPreviousPage}
          current={currentPage}
          total={pageCount}
          outset
          mt={-18}
        />

        <Box classes={['flex', 'justify-center']} mt="24px">
          <Text
            color={colors.lightContentGrey}
            lineHeight="0.8"
            fontSize="14px"
            letterSpacing="0.44px"
          >
            {currentPage + 1} of {pageCount}
          </Text>
        </Box>
      </Hide>

      {fullWidth && (
        <Hide xs sm>
          <Box classes={['flex', 'align-center', 'justify-center']} mt="24px">
            <Button
              onClick={goToPreviousPage}
              disabled={!hasPreviousPage}
              data-qa-id="prev-media"
              variant="tertiary"
            >
              {getText('Previous')}
            </Button>

            <Text
              color={colors.lightContentGrey}
              m="0 10px"
              p="0 10px"
              borderLeft={`1px solid ${colors.elementGrey}`}
              borderRight={`1px solid ${colors.elementGrey}`}
              lineHeight="0.8"
              fontSize="14px"
              letterSpacing="0.44px"
            >
              {currentPage + 1} of {pageCount}
            </Text>

            <Button
              onClick={goToNextPage}
              disabled={!hasNextPage}
              data-qa-id="next-media"
              variant="tertiary"
            >
              {getText('Next')}
            </Button>
          </Box>
        </Hide>
      )}
    </>
  );
}
